/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { FormFieldComponentDelegate } from '../core';
import { SLIDER_CONSTANTS } from './slider-constants';
export class SliderComponentDelegate extends FormFieldComponentDelegate {
    constructor(config) {
        super(config);
    }
    get value() {
        return this._element.value;
    }
    set value(value) {
        this._element.value = value;
    }
    get valueStart() {
        return this._element.valueStart;
    }
    set valueStart(value) {
        this._element.valueStart = value;
    }
    get valueEnd() {
        return this._element.valueEnd;
    }
    set valueEnd(value) {
        this._element.valueEnd = value;
    }
    get disabled() {
        return this._element.disabled;
    }
    set disabled(value) {
        this._element.disabled = value;
    }
    get min() {
        return this._element.min;
    }
    set min(value) {
        this._element.min = value;
    }
    get max() {
        return this._element.max;
    }
    set max(value) {
        this._element.max = value;
    }
    get step() {
        return this._element.step;
    }
    get range() {
        return this._element.range;
    }
    set range(value) {
        this._element.range = value;
    }
    get tickmarks() {
        return this._element.tickmarks;
    }
    set tickmarks(value) {
        this._element.tickmarks = value;
    }
    get labeled() {
        return this._element.labeled;
    }
    set labeled(value) {
        this._element.labeled = value;
    }
    get labelBuilder() {
        return this._element.labelBuilder;
    }
    set labelBuilder(value) {
        this._element.labelBuilder = value;
    }
    onInput(listener) {
        this._element.addEventListener('forge-slider-input', ({ detail }) => listener(detail));
    }
    onChange(listener) {
        this._element.addEventListener('forge-slider-change', ({ detail }) => listener(detail));
    }
    onRangeInput(listener) {
        this._element.addEventListener('forge-slider-range-input', ({ detail }) => listener(detail));
    }
    onRangeChange(listener) {
        this._element.addEventListener('forge-slider-range-change', ({ detail }) => listener(detail));
    }
    onFocus(listener) {
        this._element.addEventListener('focus', evt => listener(evt));
    }
    onBlur(listener) {
        this._element.addEventListener('blur', evt => listener(evt));
    }
    _build() {
        return document.createElement(SLIDER_CONSTANTS.elementName);
    }
}
